import { MenuItem, TextField } from "@mui/material";
import { sortByKey } from "@notemeal/utils-sort";
import { TeamPreviewFragment } from "../../../types";

export interface TeamMultiSelectProps {
  onChange: (selectedTeams: readonly TeamPreviewFragment[]) => void;
  allTeams: readonly TeamPreviewFragment[];
  selectedTeams: readonly TeamPreviewFragment[];
  disabled?: boolean;
  fullWidth?: boolean;
  displayedTeamsCount?: number;
  error: boolean;
}

const TeamMultiSelect = ({ selectedTeams, onChange, allTeams, disabled, fullWidth, displayedTeamsCount, error }: TeamMultiSelectProps) => {
  const handleChange = (teamIds: string[]) => {
    onChange(allTeams.filter(t => teamIds.includes(t.id)));
  };

  const selectedTeamIds = selectedTeams.map(t => t.id);

  return (
    <TextField
      select
      SelectProps={{
        multiple: true,
        renderValue: value => {
          const teamIds = value as string[];
          const displayTeamIds = teamIds.slice(0, displayedTeamsCount || 3);
          const displayTeamNames = displayTeamIds.map(tId => {
            const matchingTeam = allTeams.find(t => t.id === tId);
            return matchingTeam ? matchingTeam.name : "";
          });
          const hiddenTeamCount = teamIds.slice(displayedTeamsCount || 3).length;
          return (
            <div>
              {displayTeamNames.join(", ")} {hiddenTeamCount > 0 ? `(+${hiddenTeamCount})` : ""}
            </div>
          );
        },
      }}
      label="Teams"
      inputProps={{
        "aria-label": "Teams",
      }}
      value={selectedTeams.map(t => t.id)}
      sx={{ minWidth: "376px" }}
      disabled={disabled}
      fullWidth={fullWidth}
      onChange={e => handleChange(e.target.value as unknown as string[])}
      error={error}
      helperText={error ? "Required to assign teams and/or athletes!" : undefined}
    >
      {sortByKey(allTeams, "name").map(t => (
        <MenuItem key={t.id} value={t.id} sx={{ fontWeight: selectedTeamIds.includes(t.id) ? "bold" : undefined }}>
          {t.name}
        </MenuItem>
      ))}
    </TextField>
  );
};

export default TeamMultiSelect;
